import EtnersCommonUtil from '@/common/etners.common.util'

/**
 * @author : Choetruth
 * @date : 2023-10-10
 * @description : 비밀번호 유효성 검증
 * @param pwd :: 새 비밀번호
 * @param confirmPwd :: 새 비밀번호 확인
 * [ check list ]
 *    1. 비밀번호 입력 여부
 *    2. 공백 x
 *    3. 새 비밀번호 === 새 비밀번호 확인
 *    4. 영문, 숫자, 특수기호를 혼합한 8~50자리
 *
 *  ( 아래 조건은 검토중 -> 주석 )
 *    5. 같은 문자 연속 3개 이상 x, ex) 111, aaa, AAA
 *    6. 연속된 키보드 문자 3번 이상 x, ex) 123, qwe, ewq, QWE,EWQ
 *    7. 연속된 문자열 3개 이상 x, ex) 123, abc
 *    8. 한글 x
 * @returns {boolean}
 */
const validation = function(pwd, confirmPwd) {

  if (!pwd || !confirmPwd){
    kendo.alert('새 비밀번호를 입력해주세요.')
    return false
  }
  if (spacePwd(pwd)) {
    kendo.alert("비밀번호는 공백 없이 입력해주세요.")
    return false
  }
  if (sameNewPwd(pwd, confirmPwd)) {
    kendo.alert('새 비밀번호와 일치하지 않습니다. 기재한 비밀번호를 확인해주세요.')
    return false
  }
  if (combinationPwd(pwd)) {
    kendo.alert('비밀번호는 8자 이상의 문자,숫자,특문으로 작성해주세요.')
    return false
  }
  // if (sameStrPwd(pwd)) {
  //   kendo.alert('같은 문자를 3번 이상 사용할 수 없습니다.')
  //   return false
  // }
  // if (hangulPwd(pwd)) {
  //   kendo.alert('비밀번호에 한글을 사용할 수 없습니다.')
  //   return false
  // }
  // if (continuousKeyboardPwd(pwd, 2)) {
  //   kendo.alert('3개 이상의 연속된 키보드의 문자열을 사용할 수 없습니다.')
  //   return false
  // }
  // if (continuousStrPwd(pwd, 2)) {
  //   kendo.alert('3개 이상의 연속된 문자열을 사용할 수 없습니다.')
  //   return false
  // }

  return true
}

/**
 * 2. 문자열에 공백이 있는지 판단
 * @param pwd :: 비밀번호
 * @returns {boolean} :: 공백이 없으면 -1 => true
 */
const spacePwd = function (pwd) {
  const space = pwd.search(/\s/)
  return space != -1
}

/**
 * 3. 새 비밀번호 === 새 비밀번호 확인
 * @param pwd :: 새 비밀번호
 * @param confirmPwd :: 새 비밀번호 확인
 * @returns {boolean}
 */
const sameNewPwd = function (pwd, confirmPwd) {
  return pwd !== confirmPwd
}

/**
 * 4. 영문, 숫자, 특수기호를 혼합한 8~50자리
 * @param pwd :: 비밀번호
 * @returns {boolean} :: 조건에 부합하는 문자열의 경우 matched => true
 */
const combinationPwd = function (pwd) {
  const matched = /(?=.*\d{1,50})(?=.*[~`!@#$%\^&*()-+=]{1,50})(?=.*[a-zA-Z]{1,50}).{8,50}$/.test(pwd)
  return !matched
}

/**
 * 5. 같은 문자 연속 3개 이상 x, ex) 111, aaa, AAA, !!!
 * @param pwd :: 비밀번호
 * @returns {boolean}
 */
const sameStrPwd = function (pwd) {
  const sameString = /(\w)\1\1/.test(pwd) // 영문자, 숫자
  const sameSpecial = /([\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"])\1\1/.test(pwd) // 특수기호
  return sameString || sameSpecial
}

/**
 * 6. 연속된 키보드 문자 3번 이상 x, ex) 123, qwe, ewq, QWE,EWQ
 * @param value :: 비밀번호
 * @param max :: 최대 연속될 수 있는 개수
 * @returns {boolean}
 */
const continuousKeyboard = (value, max) => {
  // 대문자로 바뀔 수 있는 문자
  const word = ['qwertyuiop', 'asdfghjkl', 'zxcvbnm']
  // 숫자를 제외한 문자 대문자로
  const wordAll = ['1234567890', '~!@#$%^&*()_+', ...word, ...word.map(v => v.toUpperCase())]
  // 해당 문자 배열을 역순으로 조건 생성
  const reverseWord = [...wordAll.map(v => [...v].reverse().join(''))]
  // 생성한 조건을 합치기
  const keyboard = [...wordAll, ...reverseWord]
  for (let i = 0; i < value.length - max; i++) {
    const sliceValue = value.substring(i, i + (max+1))
    if (keyboard.some((code) => code.includes(sliceValue))) {
      return true
    }
  }
  return false
}
const continuousKeyboardPwd = function (pwd, max) {
  return continuousKeyboard(pwd, max)
}

/**
 * 7. 연속된 문자열 3개 이상 x, ex) 123, abc
 * @param value :: 비밀번호
 * @param max :: 최대 연속될 수 있는 개수
 * @returns {boolean}
 */
const continuousStr = (value, max) => {
  const str = [...value].map(v => v.charCodeAt())
  let preStr = 0
  let chr = 0
  str.forEach(s => {
    if (Math.abs(preStr - s) == 1) {
      chr++
    } else if(chr == 1 && Math.abs(preStr - s) != 1){
      chr = 0
    }
    preStr = s
  })
  return chr >= max
}
const continuousStrPwd = function (pwd, max) {
  return continuousStr(pwd, max)
}

/**
 * 8. 한글 x
 * @param pwd :: 비밀번호
 * @returns {boolean}
 */
const hangulPwd = function (pwd) {
  const hangul = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/.test(pwd)
  return hangul
}

export default {
  validation,
  spacePwd,
  sameNewPwd,
  combinationPwd,
  sameStrPwd,
  continuousKeyboardPwd,
  continuousStrPwd,
  hangulPwd,
}
